module.exports = __webpack_public_path__ + "static/media/ally_pro_5.3155a96c.jpg";